import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "col-4 offset-4"
}
const _hoisted_2 = { class: "text-h6 text-center" }
const _hoisted_3 = {
  key: 0,
  class: "text-h6 text-center"
}

import { storeToRefs } from 'pinia'
import { computed } from 'vue'
import { useUserStore } from '../../store/useUserStore'
import { isSyncing } from '../../synchronizations/sync'
import { useTimers } from '../../store/timers'
import { useRoute } from 'vue-router'
import { useI18n } from 'vue-i18n'


export default /*#__PURE__*/_defineComponent({
  __name: 'TimelineWelcomeMessage',
  props: {
    showId: { type: Boolean, default: false }
  },
  setup(__props: any) {

const { getAllParentTimers } = storeToRefs(useTimers())

/**
 * This component displays a welcome message.
 * If no timers are logged, it will welcome the rep (by name)
 * If no data are initialized - it will let the rep know.
 */
// eslint-disable-next-line
const props = __props

const { t } = useI18n({ useScope: 'global' })
const label = (key: string) => t(`timeline.${key}`)

const route = useRoute()
//show message if no timers are logged
const showMessage = computed(() => {
  return getAllParentTimers.value.length < 1 || route.name == 'userInfo'
})
const { first_name, last_name, id: userID } = storeToRefs(useUserStore())
//Welcome message. If no user data, let know app is syncing.
const welcomeMessage = computed(() => {
  if (userID.value.length) {
    return `${label('welcome')}
    ${first_name.value} ${last_name.value}`
  } else {
    //not logged in
    if (!isSyncing.value) {
      return label('pleaseSync')
    } else {
      return label('initializing')
    }
  }
})

return (_ctx: any,_cache: any) => {
  return (showMessage.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("h1", _hoisted_2, _toDisplayString(welcomeMessage.value), 1),
        (_ctx.showId && _unref(userID).length)
          ? (_openBlock(), _createElementBlock("h1", _hoisted_3, "ID: " + _toDisplayString(_unref(userID)), 1))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}
}

})